module.exports = __webpack_public_path__ + "static/media/icon_android.ca3e8ae9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Support/components/imgs/icon_android.svg
// module id = 823
// module chunks = 0